export const filterRoutesOfMembership = (membershipData, routes) => {
  // Convertir las fechas de la membresía a objetos Date para comparación
  const startDate = new Date(membershipData.paymentDate);
  const endDate = new Date(membershipData.expiresDateMembership);

  // Filtrar las rutas creadas dentro del periodo de la membresía
  const routesInMembershipPeriod = routes.filter((route) => {
    const routeDate = new Date(route.createdAt);
    return routeDate >= startDate && routeDate <= endDate;
  });

  // Contar las rutas filtradas
  // console.log(routesInMembershipPeriod);

  return routesInMembershipPeriod.length ?? [];
};
